import { AdvertisementsIcon } from './AdvertisementsIcon';

/**
 * author: Michael Irigoyen
 * id F368D23C-0F09-44D6-8487-F3229BEB6F1C
 * name advertisements
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/advertisements.svg
 * tags
 */
export const AdsIcon = AdvertisementsIcon;
export default AdsIcon